const players = document.querySelectorAll('.audio-player');
players.forEach(player => {
    const audio = player.querySelector('.audio');
    const playPauseBtn = player.querySelector('.play-pause');
    const playIcon = playPauseBtn.querySelector('.icon-play');
    const pauseIcon = playPauseBtn.querySelector('.icon-pause');
    const seekBar = player.querySelector('.seek-bar');

    const showPlayIcon = () => {
        playIcon.style.display = '';
        pauseIcon.style.display = 'none';
    };

    const showPauseIcon = () => {
        playIcon.style.display = 'none';
        pauseIcon.style.display = '';
    };

    playPauseBtn.addEventListener('click', () => {
        // Pause all other players
        players.forEach(otherPlayer => {
            const otherAudio = otherPlayer.querySelector('.audio');
            const otherPlayPauseBtn = otherPlayer.querySelector('.play-pause');
            const otherPlayIcon = otherPlayPauseBtn.querySelector('.icon-play');
            const otherPauseIcon = otherPlayPauseBtn.querySelector('.icon-pause');
            if (otherAudio !== audio) {
                otherAudio.pause();
                otherPlayIcon.style.display = '';
                otherPauseIcon.style.display = 'none';
            }
        });

        // Play/Pause current player
        if (audio.paused) {
            audio.play();
            showPauseIcon();
        } else {
            audio.pause();
            showPlayIcon();
        }
    });

    audio.addEventListener('loadedmetadata', () => {
        if (!isNaN(audio.duration)) {
            seekBar.max = audio.duration;
        }
    });

    audio.addEventListener('timeupdate', () => {
        if (!isNaN(audio.currentTime)) {
            seekBar.value = audio.currentTime;
        }
    });

    seekBar.addEventListener('input', () => {
        audio.currentTime = seekBar.value;
    });

    audio.addEventListener('pause', showPlayIcon);
    audio.addEventListener('ended', showPlayIcon);
});